"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDnd = require("react-dnd");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@material-ui/styles");

var _EditOutlined = _interopRequireDefault(require("@material-ui/icons/EditOutlined"));

var _NoteOutlined = _interopRequireDefault(require("@material-ui/icons/NoteOutlined"));

var _CropLandscape = _interopRequireDefault(require("@material-ui/icons/CropLandscape"));

var _CheckBoxOutlined = _interopRequireDefault(require("@material-ui/icons/CheckBoxOutlined"));

var _ListOutlined = _interopRequireDefault(require("@material-ui/icons/ListOutlined"));

var _SearchOutlined = _interopRequireDefault(require("@material-ui/icons/SearchOutlined"));

var _AppsOutlined = _interopRequireDefault(require("@material-ui/icons/AppsOutlined"));

var _RadioButtonChecked = _interopRequireDefault(require("@material-ui/icons/RadioButtonChecked"));

var _CalendarToday = _interopRequireDefault(require("@material-ui/icons/CalendarToday"));

var _Label = _interopRequireDefault(require("@material-ui/icons/Label"));

var _Dehaze = _interopRequireDefault(require("@material-ui/icons/Dehaze"));

var _Dashboard = _interopRequireDefault(require("@material-ui/icons/Dashboard"));

var _Image = _interopRequireDefault(require("@material-ui/icons/Image"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    container: {
      textTransform: "capitalize",
      margin: 10,
      marginBottom: 25,
      textAlign: "center",
      cursor: "move"
    },
    flex: {
      display: "flex",
      justifyContent: "flex-start",
      "@media (max-width: 1200px)": {
        justifyContent: "center"
      }
    }
  };
});

var ResponsiveSpan = _styledComponents.default.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  @media only screen and (max-width: 1200px) {\n    & > span {\n      display: none;\n    }\n    & > i {\n      margin: 0;\n    }\n  }\n"])));

var itemSource = {
  beginDrag: function beginDrag(props) {
    return props.item;
  },
  endDrag: function endDrag(props, monitor) {
    if (!monitor.didDrop()) {
      return;
    }

    var item = props.item;
    var result = monitor.getDropResult();
    item.y = result.row;
    item.x = result.col;
    return props.handleDrop(item);
  }
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
  };
}

var renderIcon = function renderIcon(param) {
  switch (param.toUpperCase()) {
    case "LABEL":
      return /*#__PURE__*/_react.default.createElement(_Label.default, {
        fontSize: "small"
      });

    case "INPUT":
      return /*#__PURE__*/_react.default.createElement(_EditOutlined.default, {
        fontSize: "small"
      });

    case "DATE":
      return /*#__PURE__*/_react.default.createElement(_CalendarToday.default, {
        fontSize: "small"
      });

    case "TEXTAREA":
      return /*#__PURE__*/_react.default.createElement(_NoteOutlined.default, {
        fontSize: "small"
      });

    case "BUTTON":
      return /*#__PURE__*/_react.default.createElement(_CropLandscape.default, {
        fontSize: "small"
      });

    case "CHECKBOX":
      return /*#__PURE__*/_react.default.createElement(_CheckBoxOutlined.default, {
        fontSize: "small"
      });

    case "RADIO":
      return /*#__PURE__*/_react.default.createElement(_RadioButtonChecked.default, {
        fontSize: "small"
      });

    case "SELECT":
      return /*#__PURE__*/_react.default.createElement(_ListOutlined.default, {
        fontSize: "small"
      });

    case "ACCORDION":
      return /*#__PURE__*/_react.default.createElement(_Dehaze.default, {
        fontSize: "small"
      });

    case "AUTOCOMPLETE":
      return /*#__PURE__*/_react.default.createElement(_SearchOutlined.default, {
        fontSize: "small"
      });

    case "DATAGRID":
      return /*#__PURE__*/_react.default.createElement(_AppsOutlined.default, {
        fontSize: "small"
      });

    case "IMAGE":
      return /*#__PURE__*/_react.default.createElement(_Image.default, {
        fontSize: "small"
      });

    case "CONTAINER":
      return /*#__PURE__*/_react.default.createElement(_Dashboard.default, {
        fontSize: "small"
      });

    default:
      return "";
  }
};

var FormItemDnd = function FormItemDnd(_ref) {
  var isDragging = _ref.isDragging,
      connectDragSource = _ref.connectDragSource,
      item = _ref.item,
      typeForm = _ref.typeForm;
  var classes = useStyles();
  var opacity = isDragging ? 0 : 1;
  return connectDragSource( /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container,
    style: {
      opacity: opacity
    }
  }, typeForm === "multiple" && item.type !== "button" && item.type !== "accordion" && /*#__PURE__*/_react.default.createElement(ResponsiveSpan, {
    className: classes.flex
  }, renderIcon(item.type), /*#__PURE__*/_react.default.createElement("span", null, item.type)), typeForm === "simple" && /*#__PURE__*/_react.default.createElement(ResponsiveSpan, {
    className: classes.flex
  }, renderIcon(item.type), /*#__PURE__*/_react.default.createElement("span", null, item.type))));
};

var _default = (0, _reactDnd.DragSource)("item", itemSource, collect)(FormItemDnd);

exports.default = _default;